import { useHotkeys } from 'react-hotkeys-hook';
import type { OptionsOrDependencyArray } from 'react-hotkeys-hook/dist/types';

export const useToolModeHotkeys = (setIsSelectMode: (value: boolean) => void, options?: OptionsOrDependencyArray) => {
  useHotkeys('v', () => setIsSelectMode(true), options);
  useHotkeys('h', () => setIsSelectMode(false), options);
};
